import { useState } from 'react';
import { History } from 'lucide-react';
import { useSelector } from 'react-redux';

import { IconButtonTemplate } from '../../buttons/IconButtonTemplate';
import { Dialog } from '../../Dialog';
import { HistoryDialog } from '../HistoryDialog';

import { selectUserToken } from '../../../../redux/features/user/userSelectors';
import {
  useGetEventLogsBySubjectQuery,
  EVENT_LOG_SUBJECTS,
} from '../../../../redux/services/eventLog/eventLogApi';

export const HistoryButton = ({ realtyId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const token = useSelector(selectUserToken);

  const { data: logs = [] } = useGetEventLogsBySubjectQuery(
    {
      token,
      subjectType: EVENT_LOG_SUBJECTS.REALTY,
      subjectId: realtyId,
    },
    { skip: !token || !realtyId }
  );

  if (logs.length === 0) return null;

  return (
    <>
      <div className="absolute left-1.5 top-1/2 -translate-y-1/2 z-[1]">
        <IconButtonTemplate
          bgColor="border-whiteColor bg-whiteColor"
          handleClick={() => setIsOpen(true)}
          icon={History}
          size={18}
          isRounded={true}
          classes="opacity-70 hover:opacity-90"
          tooltipText="Activity history"
        />
      </div>

      {isOpen && (
        <Dialog
          content={<HistoryDialog realtyId={realtyId} />}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};
